export default {
  title: 'Novinky v Qmulus',
  titleWithVersion: 'Novinky vo verzii {version}',
  doNotShowAfterUpdates: 'Nezobrazovať pri ďalších aktualizáciách',
  showAllReleases: 'Zobraziť všetky novinky',
};
